import styled from 'styled-components';

export const ImageWrapper = styled.div<{
  $aspectRatio?: string;
}>`
  position: relative;
  display: block;
  width: 100%;
  aspect-ratio: ${({ $aspectRatio }) => $aspectRatio || '1 / 1'};
  overflow: hidden; // Ensures no overflow on load
`;

export const ImageElement = styled.img<{
  $objectFit?: 'cover' | 'contain' | 'fill' | 'none' | 'scale-down';
}>`
  width: 100%;
  height: 100%;
  object-fit: ${({ $objectFit }) => $objectFit || 'cover'};
  position: absolute;
  top: 0;
  left: 0;
  transition: opacity 0.3s ease-in-out;

  &.loading {
    opacity: 0;
  }
  &.loaded {
    opacity: 1;
  }
`;
